import { render, staticRenderFns } from "./voucher-card-detail.vue?vue&type=template&id=12de2134&scoped=true&"
import script from "./voucher-card-detail.vue?vue&type=script&lang=js&"
export * from "./voucher-card-detail.vue?vue&type=script&lang=js&"
import style0 from "./voucher-card-detail.vue?vue&type=style&index=0&id=12de2134&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de2134",
  null
  
)

export default component.exports